import { AxiosResponse } from 'axios';

import { HttpClient } from 'api/HttpClient';

import {
  EntryFormRequestDto,
  EntryFormResponseDto,
  CompletedPrequalificationStepsDto,
  PrequalificationInformationDto,
  SendInviteRequestDto,
  SendInviteResponseDto,
  GetAccountStatusResponseDto,
  GetRegistrationSessionStartTimestampResponseDto,
  PrefilledEntryFormDto,
} from './prequalification.dto';
import { PrequalificationEntrySource } from './RegistrationProcess/registrationProcess.enums';

export class PrequalificationApi extends HttpClient {
  shouldAddApplicationIdInParams: boolean;

  public constructor(prequalificationEntrySource: PrequalificationEntrySource) {
    const apiPath =
      prequalificationEntrySource === PrequalificationEntrySource.Portal
        ? '/prequalification'
        : '/public/prequalification';

    super(process.env.REACT_APP_API_URL + apiPath);

    this.shouldAddApplicationIdInParams = prequalificationEntrySource === PrequalificationEntrySource.Registration;
  }

  public async getPrequalificationInformation(applicationId: string) {
    const requestUrl = this.shouldAddApplicationIdInParams ? `/${applicationId}` : '';

    return this.instance
      .get(requestUrl)
      .then((response: AxiosResponse<PrequalificationInformationDto>) => response.data);
  }

  public async getCompletedPrequalificationSteps(applicationId: string) {
    const requestUrl = this.shouldAddApplicationIdInParams ? `/${applicationId}/completed-steps` : '/completed-steps';

    return this.instance
      .get(requestUrl)
      .then((response: AxiosResponse<CompletedPrequalificationStepsDto>) => response.data);
  }

  public async updatePrequalificationInformation(
    applicationId: string,
    prequalificationInformationDto: PrequalificationInformationDto,
  ): Promise<PrequalificationInformationDto> {
    const requestUrl = this.shouldAddApplicationIdInParams ? `/${applicationId}` : '';

    return await this.instance
      .put(requestUrl, prequalificationInformationDto)
      .then((response: AxiosResponse<PrequalificationInformationDto>) => response.data);
  }

  public async submitEntryForm(entryForm: EntryFormRequestDto): Promise<EntryFormResponseDto> {
    return await this.instance
      .post('/', entryForm)
      .then((response: AxiosResponse<EntryFormResponseDto>) => response.data);
  }

  public async sendInvite(data: SendInviteRequestDto): Promise<SendInviteResponseDto> {
    return await this.instance
      .post('/invite', data)
      .then((response: AxiosResponse<SendInviteResponseDto>) => response.data);
  }

  public async getAccountStatus(applicationId: string): Promise<GetAccountStatusResponseDto> {
    const requestUrl = this.shouldAddApplicationIdInParams
      ? `/${applicationId}/main-contact-status`
      : '/main-contact-status';

    return await this.instance
      .get(requestUrl)
      .then((response: AxiosResponse<GetAccountStatusResponseDto>) => response.data);
  }

  public async getRegistrationSessionStartTimestamp(
    applicationId: string,
  ): Promise<GetRegistrationSessionStartTimestampResponseDto> {
    const requestUrl = this.shouldAddApplicationIdInParams ? `/${applicationId}/session-start` : '/session-start';

    return await this.instance
      .get(requestUrl)
      .then((response: AxiosResponse<GetRegistrationSessionStartTimestampResponseDto>) => response.data);
  }

  public async getPrefilledEntryForm(companyHubspotId: string): Promise<PrefilledEntryFormDto> {
    return await this.instance
      .get(`/prefilled-entry-form/${companyHubspotId}`)
      .then((response: AxiosResponse<PrefilledEntryFormDto>) => response.data);
  }
}
